export default "__VITE_ASSET__9f96ce83__"